import globalSV from './global.json';
import mainSV from './main.json';
import onboardingSV from './onboarding/first_step.json';
import rentalSV from './onboarding/estimate_page.json';
import onboardingSuccessSV from './onboarding/success_page.json';
import faqSV from './onboarding/faq.json';
import aboutSV from './company/about.json';
import partnerSV from './company/partner.json';
import blogSV from './company/blog.json';
import pricingSV from './company/pricing.json';
import insuranceSV from './company/insurance.json';
import securitySV from './company/security.json';
import listingsSV from './listings/list.json';
import destinationsSV from './listings/destinations.json';
import apartmentSV from './listings/apartment.json';
import successSV from './listings/success.json';
import errorSV from './error.json';
import formSV from './components/forms.json';
import sliderSV from './components/sliders.json';
import menuSV from './components/menu.json';
import guestsAuthSV from './guests/auth.json';

export const messages = {
  ...globalSV,
  onboarding: onboardingSV,
  main: mainSV,
  faq: faqSV,
  form: formSV,
  menu: menuSV,
  slider: sliderSV,
  rental: rentalSV,
  onboardingSuccess: onboardingSuccessSV,
  about: aboutSV,
  partner: partnerSV,
  blog: blogSV,
  pricing: pricingSV,
  insurance: insuranceSV,
  security: securitySV,
  listings: listingsSV,
  destinations: destinationsSV,
  apartment: apartmentSV,
  success: successSV,
  error: errorSV,
  auth: guestsAuthSV,
};
